import React, { Component } from 'react';
import { branch } from 'baobab-react/higher-order';
import ButtonLink from '../../common/TrackedButtonLink';
import CmsContentWrapper from "../../common/CmsContentWrapper";

class HeroStatic extends Component {
    componentDidMount() {
    }

    render() {
        const {imgSrc, imgSrcMobile, imgAlt, title, body, ctaUrl, ctaText} = this.props.data;
        return (
            <header className="hero-static">
                <picture>
                    <source media="(max-width: 766px)" srcSet={imgSrcMobile} />
                    <img
                        src={imgSrc}
                        alt={imgAlt}
                        className="hero-static-image"/>
                </picture>
                <div className="hero-static-content dark">
                    <div className="row">
                        <div className="col md-5 my-md-5 py-md-5">
                            <h1 className="mb-md-3 title uppercase">{title}</h1>
                            <CmsContentWrapper html={body} className="mb-md-4" />
                            <ButtonLink
                                to={ctaUrl}
                                className="btn-primary"
                                target='_self'
                                rel="noopener">
                                {ctaText}
                            </ButtonLink>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}

export default branch({
}, HeroStatic);



// WEBPACK FOOTER //
// ./src/pages/components/page/HeroStatic.js